module.exports = __webpack_public_path__ + "media/entities/2313_old-4e284979.png";